import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { ofType } from 'redux-observable-es6-compat';

import { TFamily, TPlaylist, TRemote, ASetFamilies, ASetFamily } from '../actions';
import { EventFamily, Playlist } from '../entities';

interface Dependencies {
  restApi: {
    get<T>(string, number): Observable<T>;
  };
}

const familiesListeners = [
  TFamily.FETCH_FAMILIES,
  TRemote.SET_REMOTE,
];

let familiesEpicTimeout = 0;

export const fetchFamiliesEpic = (action$, _, { restApi }: Dependencies) =>
  action$.pipe(
    filter(({ type }) => familiesListeners.includes(type)),
    filter(() => new Date().getTime() - familiesEpicTimeout > 2000),
    tap(() => familiesEpicTimeout = new Date().getTime()),
    switchMap(() => restApi.get<EventFamily[]>('/eventfamily', 15000)),
    map(ASetFamilies),
  );

export const createPlaylistEpic = (action$, state$) =>
  action$.pipe(
    ofType(TPlaylist.CREATE_PLAYLIST),
    map(({ payload }) => {
      const myPlaylists: EventFamily = Object.values(state$.value.families).find(({ myPlaylist }) => myPlaylist);
      const newPlaylist: Playlist = state$.value.playlists.events[payload.id];
      return {
        ...myPlaylists,
        events: [...myPlaylists.events, newPlaylist]
      };
    }),
    map(ASetFamily)
  );
